export default __webpack_public_path__ + "static/media/xnft white 1.db49260f.svg";